// editor instance
export const editorInstanceDefault = undefined;

// editor focused element
export const editorFocusedEleDefault = undefined;

// editor data
export const editorDataDefault = '';
